// eslint-disable-next-line no-use-before-define
import React from 'react';

import {
  TreeShipViewItemInfoType,
  TreeSupplierViewItemInfoType,
} from '../../types/EquipmentTypes';
import { Box, Box2, Box3, InnerCardWrapper, Spacer } from './Tree.styles';

type ItemType = TreeShipViewItemInfoType | TreeSupplierViewItemInfoType;

export interface TreeViewStructureType {
  title: string;
  items: Array<
    ItemType & {
      items?: ItemType[];
    }
  >;
}

interface TreeViewProps {
  expanded?: string[];
  showCard: (arg0: unknown, arg1?: unknown, arg2?: unknown) => void;
  structure: TreeViewStructureType[];
}

const TreeView = ({
  expanded,
  showCard,
  structure,
}: TreeViewProps): JSX.Element => (
  <>
    {structure.map((category) => (
      <div key={category.title}>
        {showCard(category)}
        {category.items.map((j, jIndex) => (
          <React.Fragment key={`${category.title}|${j.title}`}>
            {(!expanded || expanded?.includes(category.title)) && (
              <div>
                <InnerCardWrapper index={jIndex}>
                  <div>
                    <Box />
                    <Box2 isLast={category.items.length === jIndex + 1} />
                  </div>
                  {showCard(j, category)}
                </InnerCardWrapper>
                {(!expanded ||
                  expanded?.includes(`${category.title}|${j.title}`)) &&
                  j.items.map((k, kIndex) => (
                    <InnerCardWrapper
                      key={`${category.title}|${j.title}|${k.title}`}
                    >
                      <div>
                        <Box3 isLast={category.items.length === jIndex + 1} />
                        <Box2 isLast={category.items.length === jIndex + 1} />
                      </div>
                      <div>
                        <Box />
                        {j.items.length !== kIndex + 1 && <Box2 />}
                      </div>
                      {showCard(k, category, j)}
                    </InnerCardWrapper>
                  ))}
              </div>
            )}
          </React.Fragment>
        ))}
        <Spacer />
      </div>
    ))}
  </>
);

export default TreeView;
